export default function exportParticipants(params) {
    let filetype = "xlsx";
    let filename = "Prezenční listina - " + params.name;
  
    this.printFile({module: params.module, id: params.id, name: filename, type: "ExportParticipants", filename, filetype});
  }